/**
 * Hide content when the user is not authenticated.
 *
 * Remove {@link !Element} matching `[data-only-user]` if the `authUser` is not set.
 *
 * @example
 * ```html
 * <strong data-only-user>You are logged in!</strong>
 * ```
 *
 * @module data-only-user
 * @author Jacob Viertel <jv@onscreen.net>
 * @since 3.84.0
 * @see [authUser](../context/auth-user.js)
 */
import {removeNode} from '@acng/frontend-bounty';
import {defineCompileAttribute} from '@acng/frontend-stargazer';

import {authUser} from '../context/auth-user.js';

const MODULE = 'userPool/attribute/only-user';
const VERBOSE = false;
DEBUG: if (VERBOSE) console.warn('Import verbose', MODULE);

defineCompileAttribute('data-only-user', (element, _1, _2, compiler) => {
  ASSERT: console.warn(`[data-only-user] is deprecated. Use [if-user].`, {element, compiler});
  DEBUG: if (VERBOSE || element.hasAttribute('debug')) console.debug(MODULE, {element});

  if (!authUser) {
    DEBUG: if (VERBOSE || element.hasAttribute('debug')) console.info(MODULE, 'remove', {element});

    removeNode(element);
  }
});
